import React from 'react';
import { Text, DropdownBase, TextButton, Box } from '@wix/design-system';
import { ChevronDown } from '@wix/wix-ui-icons-common';

export interface SortByDropdownOption {
  id: string;
  value: string;
}

interface LabeledDropdownProps {
  label: string;
  options: SortByDropdownOption[];
  selectedId: string;
  onChange: (id: string) => void;
  dataHook?: string;
}

export const LabeledDropdown: React.FC<LabeledDropdownProps> = ({
  label,
  options,
  selectedId,
  onChange,
  dataHook,
}) => (
  <Box dataHook={dataHook}>
    <Text>{label}</Text>
    <DropdownBase
      placement="bottom"
      options={options}
      dataHook={`${dataHook}-dropdown`}
      selectedId={selectedId}
      focusOnSelectedOption={true}
      onSelect={(e) => onChange(e.id.toString())}
    >
      {({ toggle }) => (
        <TextButton
          skin="dark"
          onClick={toggle}
          suffixIcon={<ChevronDown />}
          weight="normal"
          style={{ paddingLeft: '12px' }}
          dataHook={`${dataHook}-button`}
        >
          {options.find((option) => option.id === selectedId)?.value}
        </TextButton>
      )}
    </DropdownBase>
  </Box>
);
